import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=71f12056&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f12056')) {
      api.createRecord('71f12056', component.options)
    } else {
      api.reload('71f12056', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=71f12056&", function () {
      api.rerender('71f12056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4nfp8MiWe6vGD/JS/comp/openstreetmap.vue"
export default component.exports